import React, { useState } from 'react';
import { BrowserRouter as Router, Routes, Route } from 'react-router-dom';
import Header from './components/Header';
import Footer from './components/Footer';
import ScrollToTop from './components/ScrollToTop';
import Home from './pages/Home/Home';
import About from './pages/About/About';
import Contact from './pages/Contact/Contact';
import FAQ from './pages/FAQ/FAQ';
import Privacy from './pages/Privacy/Privacy';
import Terms from './pages/Terms/Terms';
import Cookies from './pages/Cookies/Cookies';
import Launch from './pages/Launch/Launch';
import GiftClaim from './pages/GiftClaim/GiftClaim';
import { WaitlistModal, WaitlistInitialData } from './components/WaitlistModal';

function App() {
  const [waitlistOpen, setWaitlistOpen] = useState(false);
  const [waitlistTab, setWaitlistTab] = useState<'customer' | 'vendor' | 'rider'>('customer');
  const [waitlistInitialData, setWaitlistInitialData] = useState<WaitlistInitialData | undefined>(undefined);

  const handleOpenWaitlist = (
    tab: 'customer' | 'vendor' | 'rider' = 'customer',
    data?: WaitlistInitialData
  ) => {
    setWaitlistTab(tab);
    setWaitlistInitialData(data);
    setWaitlistOpen(true);
  };

  return (
    <Router>
      <ScrollToTop />
      <div className="min-h-screen flex flex-col bg-gray-50">
        <Header onOpenWaitlist={handleOpenWaitlist} />
        <main className="flex-grow">
          <Routes>
            <Route path="/" element={<Home onOpenWaitlist={handleOpenWaitlist} />} />
            <Route path="/join" element={<Home onOpenWaitlist={handleOpenWaitlist} defaultOpenWaitlist={true} />} />
            <Route path="/about" element={<About />} />
            <Route path="/contact" element={<Contact />} />
            <Route path="/faq" element={<FAQ />} />
            <Route path="/privacy" element={<Privacy />} />
            <Route path="/acceptable-use" element={<Privacy defaultTab="acceptable-use" />} />
            <Route path="/acceptable-use-policy" element={<Privacy defaultTab="acceptable-use" />} />
            <Route path="/refund-policy" element={<Privacy defaultTab="refund-policy" />} />
            <Route path="/terms" element={<Terms />} />
            <Route path="/launch" element={<Launch />} />
            <Route path="/cookies" element={<Cookies />} />
            <Route path="/gift/claim/:token" element={<GiftClaim />} />
            <Route path="/gifts/claim/:token" element={<GiftClaim />} />
            <Route path="/claim/:token" element={<GiftClaim />} />
          </Routes>
        </main>
        <WaitlistModal
          isOpen={waitlistOpen}
          onClose={() => setWaitlistOpen(false)}
          initialTab={waitlistTab}
          initialData={waitlistInitialData}
        />
        <Footer />
      </div>
    </Router>
  );
}

export default App;
